/** The asset the three lead rows describe, as address only, coordinates only, then both. */
export const portfolioTemplateLeadAsset = {
  address: "23 Price St, Nerang QLD 4211",
  lat: -27.989413,
  lng: 153.336063,
  elevation: 12,
};

type PortfolioTemplateAsset = {
  lat: number;
  lng: number;
  //  CUSTOM override for MaximumVulnerability to use residential financial defaults
  pricedAs?: string;
};

/**
 * Sample coordinates for the per-archetype rows of the portfolio upload
 * templates, keyed by archetype value. Spread across the globe so the sample
 * rows exercise a range of hazards.
 *
 * Archetypes missing from this map (HKMA SPECIFIC) fall back
 * to a grid around the region template's centre.
 */
export const portfolioExportExampleAssets: Record<string, PortfolioTemplateAsset> = {
  FreestandingHouse: { lat: 9.458660916, lng: -63.70451257 },
  HighRiseFlat: { lat: -6.300607792, lng: -39.2882779 },
  LowRiseFlat: { lat: -38.18007277, lng: -72.32742865 },
  MediumDensityAttached: { lat: -34.76453178, lng: -58.56194768 },
  MediumDensityDetached: { lat: -36.00202554, lng: -59.12675332 },
  SimpleOffice: { lat: 51.10997846, lng: -114.1666782 },
  LowRiseStructure: { lat: 63.5532382, lng: 29.09695796 },
  HighRiseStructure: { lat: -33.766035, lng: 150.902411 },
  Supermarket: { lat: 54.795385, lng: -127.1612194 },
  AdvancedWaterTreatment: { lat: 25.020364, lng: 32.872351 },
  AmbulanceStation: { lat: 25.2298782, lng: 30.5825901 },
  Berth: { lat: 59.03811572, lng: -158.4753652 },
  ControlRoom: { lat: 7.321721692, lng: 3.801868384 },
  CouncilBuilding: { lat: 10.27933796, lng: 16.97043424 },
  FibreJunction: { lat: 11.19491356, lng: 35.05009828 },
  FlexiblePavement: { lat: 56.831288, lng: 53.17414 },
  GasDistribution: { lat: 27.085174, lng: 112.941941 },
  GenericIndustrial: { lat: 72.58830602, lng: 75.45741349 },
  Girder: { lat: 66.21153175, lng: 77.25391432 },
  Hospital: { lat: 60.80250015, lng: 69.58381893 },
  Pipe: { lat: 60.04630887, lng: 144.8391149 },
  Overhead: { lat: 50.19199327, lng: 136.9599436 },
  Park: { lat: 61.53108409, lng: 156.7029011 },
  ParkComplex: { lat: 30.92215513, lng: 47.44563067 },
  MainSwitchboard: { lat: 38.48784837, lng: 45.7076409 },
  PressureMain: { lat: 33.2790789, lng: 75.01524368 },
  Prison: { lat: 34.51541988, lng: 109.0624519 },
  RigidPavement: { lat: 39.10427632, lng: 121.8155442 },
  RisingMain: { lat: 50.2623366, lng: -98.94276346 },
  School: { lat: 31.75670803, lng: 118.9206802 },
  SewageMechanised: { lat: 22.40386474, lng: 112.8555615 },
  Shiploader: { lat: 6.798688, lng: -58.152792 },
  Station: { lat: 24.18438872, lng: 55.78873068 },
  StormWaterPit: { lat: 50.10799879, lng: -102.6387692 },
  Substation: { lat: 20.5252445, lng: 77.57176168 },
  Tower: { lat: 13.67644359, lng: 100.4470885 },
  TrackMain: { lat: -7.593579951, lng: 112.128998 },
  Transformer: { lat: -16.42321181, lng: 136.0929122 },
  Truss: { lat: -20.56242804, lng: 118.6898457 },
  Tunnel: { lat: -35.55368715, lng: 138.606067 },
  AeratedLagoon: { lat: -34.46397208, lng: 138.967023 },
  NaturalLagoon: { lat: 41.06036361, lng: -112.0610903 },
  WindTurbine: { lat: 39.88588001, lng: -105.0489954 },
  DataCenter: { lat: 38.72142053, lng: -121.2218389 },
  FibreNode: { lat: 63.85593087, lng: -21.38529016 },
  // published template prices this bare-land archetype residentially, not as industrial
  MaximumVulnerability: { lat: 29.25240214, lng: 6.487747362, pricedAs: "FreestandingHouse" },
};
